import {LayerDef} from "./LayerDef";
import {Hill} from "./Hill";
import {HillLists, LayerDefBase} from "./LayerDefBase";
import {COLOURS} from "./Colours";
import {Style} from "ol/style";

export class FionasLayerDef extends LayerDefBase implements LayerDef {
    private visitedStyle = LayerDefBase.buildStyle(5, COLOURS.FIONA.VISITED);
    private unvisitedStyle = LayerDefBase.buildStyle(
        5,
        COLOURS.FIONA.UNVISITED
    );

    isVisible(): boolean {
        return false;
    }

    getProgressElement(): HTMLDivElement {
        return document.getElementById("progress-fiona") as HTMLDivElement;
    }

    protected getUnvisitedStyle(): Style {
        return this.unvisitedStyle;
    }

    protected getVisitedStyle(): Style {
        return this.visitedStyle;
    }

    protected getLayerHills(hillLists: HillLists): Hill[] {
        return hillLists.main.filter((h) => h.categories.includes("FIONA"));
    }

    getName(): string {
        return "Fionas";
    }
}
